import React from "react";
import "./styles.css";

// Всплывающая подсказка при наведении/фокусе на children — CSS-only (без JS-позиционирования,
// всплывает над элементом по центру). text — строка или JSX.
export default function Tooltip({ text, className = '', children }) {
    return <span className={`tooltip ${className}`}>
        {children}
        <span className="tooltip__bubble" role="tooltip">{text}</span>
    </span>;
}
